import React from 'react';

import CustSvcTable from './CustomerSvcTable';
import Card from '../../common/card/Card';

const CustomerService = () => {
  return (
    <Card
      id="customerService"
      title="Customer Service Requests"
      // titleClassName="flex w-full justify-between align-center"
      // titleLink="View All Requests >"
      // titleLinkClassName="text-xs ml-64 text-right text-white normal-case"
    >
      <CustSvcTable />
    </Card>
  );
};

export default CustomerService;
